import { Phone, Target, Users } from 'lucide-react';
import { AnalyticsKPITile } from './AnalyticsKPITile';
import type { KPIData } from '@/hooks/useAnalyticsKPIs';

interface ReferralsData {
  current: number;
  previous: number;
  deltaPct: number | null;
}

interface MeaningfulTargetData {
  current: number;
  target: number;
  pct: number;
}

interface AnalyticsKPIRowProps {
  data: KPIData | null;
  isLoading: boolean;
  error: Error | null;
  onClickCalls?: () => void;
  referralsData: ReferralsData;
  onClickReferrals?: () => void;
  meaningfulTarget?: MeaningfulTargetData;
  onClickMeaningfulTarget?: () => void;
}

export function AnalyticsKPIRow(props: AnalyticsKPIRowProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <AnalyticsKPITile
        variant="hero"
        label="Calls"
        value={props.data?.calls.current ?? 0}
        deltaPct={props.data?.calls.deltaPct ?? null}
        icon={Phone}
        onClick={props.onClickCalls}
        isLoading={props.isLoading}
        error={props.error}
      />
      <AnalyticsKPITile
        variant="hero"
        label="New Referrals"
        value={props.referralsData?.current ?? 0}
        deltaPct={props.referralsData?.deltaPct ?? null}
        icon={Users}
        onClick={props.onClickReferrals}
        isLoading={props.isLoading}
        error={props.error}
      />
      <AnalyticsKPITile
        variant="hero"
        label="Meaningful Target"
        value={`${props.meaningfulTarget?.current ?? 0}/${props.meaningfulTarget?.target ?? 0}`}
        deltaPct={null}
        icon={Target}
        onClick={props.onClickMeaningfulTarget}
        isLoading={props.isLoading}
        error={props.error}
      />
    </div>
  );
}
